import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { OPERATION_DASHBOARD, ROUTES_PATH } from '@/constants';
import ENVIRONMENT from '@/environments/environment';
import { checkIsLogged } from '@/redux/auth/auth';
import { postLeads } from '@/redux/auth/authAPI';
import { notificationService } from '@/services/notifications';
import { usernameValidation } from '@/utils/validators';
import { generateLoginTrackingParams, loginTrack } from '@/services/tracking';

export const LoginSSO = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const username = params.get('user');
  const accessToken = params.get('access_token');
  const refreshToken = params.get('refresh_token');

  const getLead = async () => {
    try {
      const leadsResponse = await postLeads();
      sessionStorage.setItem('leadToken', leadsResponse?.data.token);
      const expirationDate = new Date();
      expirationDate.setSeconds(
        expirationDate.getSeconds() + leadsResponse?.data.expires_in,
      );
      sessionStorage.setItem('expiresLeads', expirationDate.toUTCString());
    } catch (err) {
      history.push(ROUTES_PATH.LOGIN);
    }
  };

  const signIn = async () => {
    if (accessToken && username) {
      history.push(generateLoginTrackingParams(params));
      const expirationDate = new Date(
        new Date().setHours(new Date().getHours() + 2),
      ).toString();
      const userValid = usernameValidation(username);
      if (userValid) {
        localStorage.setItem('username', username.toUpperCase());
        sessionStorage.setItem('accessToken', accessToken);
        sessionStorage.setItem('expirationDate', expirationDate);
        refreshToken && sessionStorage.setItem('refreshToken', refreshToken);
        if (ENVIRONMENT.ENV) {
          loginTrack(
            username.toUpperCase(),
          );
        }
        await getLead().then(() => {
          if (!notificationService.hasEnabledNotifications()) {
            LocalNotifications.checkPermissions().then((permission) => {
              if (permission.display === 'granted') {
                notificationService.enableNotifications();
              }
            });
            history.push(OPERATION_DASHBOARD);
            dispatch(checkIsLogged());
          }
        }).catch(() => {
          history.push(ROUTES_PATH.LOGIN);
        });
      } else {
        history.push(ROUTES_PATH.LOGIN);
      }
    } else {
      history.push(ROUTES_PATH.LOGIN);
    }
  };

  useEffect(() => {
    signIn();
  }, []);

  return null;
};
